module.exports = __webpack_public_path__ + "img/advantage-07.e3e62736.png";